import React, { useContext, useEffect, useReducer } from "react";
import Topbar from "../Pages/global/Topbar";
import Sidebar from "../Pages/global/Sidebar";
import { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { createContext } from "react";
import DialogComponent from "../components/DialogComponent.jsx";
import { API, Auth } from "aws-amplify";
import { AdminlistProductsLists } from "./MutaionsAndQueries";
import AdminSidebar from "../Pages/Admin/global/AdminSidebar.jsx";
import AdminDialogComponent from "../components/Admin/AdminDialogComponent.jsx";
import AdminTopbar from '../Pages/Admin/global/AdminTopbar.jsx';
import { OraganizationList } from "../components/Admin/AdminListDetailsFunction.js";
import { FadeProvider } from "../components/FadeContext/FadeContext.jsx";
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useMediaQuery } from "@mui/material";
import Footer from "../Pages/global/Footer.jsx";
import SessionExpired from "../components/SessionExpired.jsx";
import { useTranslation } from "react-i18next";
import { FetchCartDetailsFn, fetchCustomerAddress, FetchCustomerBlockDetails, FetchFavProductsDetails, fetchNotificationDetails, FetchRestrictCustomerSpecificProductsByCustomerUUID, FetchUOMDetails, OpenSearchProductsDetails, OraganizationLists } from "./LayoutAPIs/layoutAPIs.js";
import { ResponsiveContext } from "../App.js";

export const AppContext = createContext();

const Actions = {
  RestrictProductListDataLoaded: "RestrictProductListDataLoaded",

  EmptyCatalogList: "EmptyCatalogList", LoadingCatalogList: "LoadingCatalogList",
  CatalogProductListDataLoaded: "CatalogProductListDataLoaded", CatalogProductListConcatenate: "CatalogProductListConcatenate",
  NextTokenRestart: "NextTokenRestart",

  EmptyFavList: "EmptyFavList", FavProductsListDataLoaded: "FavProductsListDataLoaded", AddFavIDs: "AddFavIDs", AddFavToFavProductList: "AddFavToFavProductList",
  RemainingFavIDs: "RemainingFavIDs", RemoveFavFromFavProductList: "RemoveFavFromFavProductList", RemainingFavProducts: "RemainingFavProducts",
  UOMlistDataLoaded: "UOMlistDataLoaded",

  CartProductsLoaded: "CartProductsLoaded", CartDetailsLoaded: 'CartDetailsLoaded',
  CartProductIDAdd: "CartProductIDAdd", CartProductAdd: "CartProductAdd", CartProductIDRemove: "CartProductIDRemove", CartProductQtyUpdate: "CartProductQtyUpdate",
  DeleteProductFromCart: "DeleteProductFromCart", CartDetailsStatusChange: "CartDetailsStatusChange", CartProductsOrdered: 'CartProductsOrdered',
  CartProductsEmpty: "CartProductsEmpty"

}

const ProductStatesInitialValues = {
  ProductCountSize: 30,
  GapFillingCount: 0,
  RestrictProductList: { Status: "Loading", Data: [] },
  CatalogProductList: { Status: "Loading", Data: [], TotalProductCount: 0, NextToken: false },
  FavProductsList: { Status: "Loading", Data: [], FavIDs: [] },
  ProductsUOMDetails: { Status: "Loading", Data: [] }
}

const ProductRelatedReducers = (state, action) => {
  switch (action.type) {
    case Actions.RestrictProductListDataLoaded:
      return { ...state, RestrictProductList: action.payload }
    case Actions.LoadingCatalogList:
      return { ...state, CatalogProductList: { Status: "Loading", Data: [], TotalProductCount: 0, NextToken: false } }
    case Actions.EmptyCatalogList:
      return { ...state, CatalogProductList: { Status: "NoData", Data: [], TotalProductCount: 0, NextToken: false } }

    case Actions.NextTokenRestart:
      return { ...state, CatalogProductList: { ...state.CatalogProductList, NextToken: false } }
    case Actions.CatalogProductListDataLoaded:
    case Actions.CatalogProductListConcatenate:
      const FullProductDetails = action.payload.Data.SearchResult;
      const RemovedRestrictData = FullProductDetails.filter((mainItem) => !state.RestrictProductList.Data.some
        ((checkItem) => checkItem === mainItem.id))
      const RestrictDataProduct = FullProductDetails.filter((mainItem) => state.RestrictProductList.Data.some
        ((checkItem) => checkItem === mainItem.id))
      if (action.type === Actions.CatalogProductListDataLoaded) {
        return {
          ...state, GapFillingCount: RestrictDataProduct.length,
          CatalogProductList: {
            Status: RemovedRestrictData.length > 0 ? "Success" : "Loading", Data: RemovedRestrictData, TotalProductCount: action.payload.Data.SearchResult.length,
            NextToken: action.payload.Data.SearchResult.length < action.payload.Data.TotalValue
          }
        }
      }
      //Load More Process of Open Search api call
      if (action.type === Actions.CatalogProductListConcatenate) {

        return {
          ...state, GapFillingCount: RestrictDataProduct.length,
          CatalogProductList: {
            Status: (RemovedRestrictData.length === 0 && state.CatalogProductList.Data.length === 0 &&
              !((action.payload.Data.SearchResult.length + state.CatalogProductList.TotalProductCount) < action.payload.Data.TotalValue))
              ? "NoData" : state.CatalogProductList.Data.length > 0 ? "Success" : "Loading",
            Data: [...state.CatalogProductList.Data, ...RemovedRestrictData],
            TotalProductCount: action.payload.Data.SearchResult.length + state.CatalogProductList.TotalProductCount,
            NextToken: (action.payload.Data.SearchResult.length + state.CatalogProductList.TotalProductCount) < action.payload.Data.TotalValue
          }
        }

      }
      break;
    case Actions.EmptyFavList:
      return { ...state, FavProductsList: { Status: "NoData", Data: [], FavIDs: [] } };
    case Actions.FavProductsListDataLoaded:
      const RemovedRestrictProduct = action.payload.Data.filter((mainItem) => !state.RestrictProductList.Data.some((checkItem) => checkItem === mainItem.productID))
      const RemoveProductDetailsNull = RemovedRestrictProduct.filter((mainItem) => mainItem.productDetail !== null)
      return {
        ...state, FavProductsList: {
          Status: "Success", Data: RemoveProductDetailsNull.map(p => ({ ...p.productDetail, AutoGenID: p.id })),
          FavIDs: RemoveProductDetailsNull.map(p => p.userFavouriteProductsProductDetailId)
        }
      }
    case Actions.AddFavIDs:
      return { ...state, FavProductsList: { ...state.FavProductsList, Status: "Success", FavIDs: [...state.FavProductsList.FavIDs, action.payload.FavIDs] } }
    case Actions.RemainingFavIDs:
      return { ...state, FavProductsList: { ...state.FavProductsList, FavIDs: action.payload.FavIDs } }
    case Actions.AddFavToFavProductList:
      const FavProductDetail = [{ ...action.payload.Data.productDetail, AutoGenID: action.payload.Data.id }]
      const AllFav = [...state.FavProductsList.FavIDs, action.payload.FavIDs]
      const FavIds = [...new Set(AllFav)]
      return {
        ...state, FavProductsList: {
          Status: "Success",
          Data: [...state.FavProductsList.Data, ...FavProductDetail],
          FavIDs: FavIds
        }
      }
    case Actions.RemainingFavProducts:
      return { ...state, FavProductsList: { ...state.FavProductsList, Data: action.payload.Data, FavIDs: action.payload.FavIDs } }
    case Actions.UOMlistDataLoaded:
      return { ...state, ProductsUOMDetails: { Status: action.payload.Status, Data: action.payload.Data } }
    default:
      return state
  }

}

const CartStatesInitialValues = {
  CartDetails: { Status: "Loading", Data: [] },
  CartProductsList: { Status: "Loading", Data: [], CartProductsIDs: [] },

}
const CartRelatedReducers = (state, action) => {
  switch (action.type) {
    case Actions.CartDetailsLoaded:
      return { ...state, CartDetails: action.payload }
    case Actions.CartProductsLoaded:
      return { ...state, CartProductsList: action.payload }
    case Actions.CartDetailsStatusChange:
      return { ...state, CartDetails: { ...state.CartDetails, Status: action.Status } }

    case Actions.CartProductAdd:
      return {
        ...state,
        CartProductsList:
        {
          ...state.CartProductsList, Status: "ProductsInCart", Data: [...state.CartProductsList.Data, action.payload]
        }
      }
    case Actions.CartProductIDAdd:
      return {
        ...state,
        CartProductsList:
        {
          ...state.CartProductsList, Status: "ProductsInCart",
          CartProductsIDs: state.CartDetails.Status === "Ordered" ? [action.payload] : Array.from(new Set([...state.CartProductsList.CartProductsIDs, action.payload]))
        }
      }
    case Actions.CartProductIDRemove:
      return {
        ...state,
        CartProductsList:
        {
          ...state.CartProductsList,
          Status: state.CartProductsList.CartProductsIDs.length === 1 ? "EmptyCart" : "ProductsInCart",
          CartProductsIDs: state.CartProductsList.CartProductsIDs.filter((item) => item !== action.payload)
        }
      }
    case Actions.CartProductQtyUpdate:
      const updatedData = state.CartProductsList.Data.map((item) => {
        if (item.id === action.payload.id) {
          return { ...item, ...action.payload };
        }
        return item;
      });
      return { ...state, CartProductsList: { ...state.CartProductsList, Data: updatedData } }
    case Actions.CartProductsInProgrss:
      return { ...state, CartProductsList: { ...state.CartProductsList, Status: "InProgress" } };
    case Actions.CartProductsOrdered:
      return { ...state, CartProductsList: { ...state.CartProductsList, Status: "Ordered", Data: [] } };
    case Actions.CartProductsEmpty:
      return { ...state, CartProductsList: { Status: "EmptyCart", Data: [], CartProductsIDs: [] } };

    case Actions.DeleteProductFromCart:
      const RemainingProducts = state.CartProductsList.Data.filter((cartProduct) => cartProduct.id !== action.payload.id);
      const RemainingProductIds = state.CartProductsList.CartProductsIDs.filter((cartProductId) => cartProductId !== action.payload.userProductsCartProductdetailsId)
      return {
        ...state, CartProductsList: {
          Status: RemainingProducts.length === 0 ? "EmptyCart" : "ProductsInCart",
          Data: RemainingProducts,
          CartProductsIDs: RemainingProductIds
        }
      }
    default:
      return state
  }
}


const Layout = (props) => {
  const { t } = useTranslation();
  const [ProductRelatedStates, ProductRelatedDispatch] = useReducer(ProductRelatedReducers, ProductStatesInitialValues);
  const [CartProductRelatedStates, CartRelatedDispatch] = useReducer(CartRelatedReducers, CartStatesInitialValues);
  // console.log("CartProductRelatedStates", CartProductRelatedStates)
  const { Mobile, Tab, Laptop, Desktop } = useContext(ResponsiveContext);
  const [MobileBackComp, setMobileBackComp] = useState(false);

  const [show, setShow] = useState("hide");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [userDetails, setUserDetails] = useState("");
  const [username, setUsername] = useState("");
  const [ProductListDetails, setProductListDetails] = useState([]);
  const [favouritesTab, setFavouritesTab] = useState(0);
  // const [hasCheckedUserCart, setHasCheckedUserCart] = useState(false);
  const [date, setDate] = useState(null);
  const [rootObject, setRootObject] = useState({});
  const [globalSearch, setGlobalSearch] = useState("");
  const [globalData, setGlobalData] = useState([]);
  const [DialogBox, setDialogBox] = useState(false);
  const [accountDetails, setaccountDetails] = useState({});
  const [isFiltered, setIsFiltered] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [taxDetails, setTaxDetails] = useState({});
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [showProductDetails, setShowProductDetails] = useState({
    show: false,
    productDetails: []
  });
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [NotificationMsg, setNotificationMsg] = useState([]);
  const [SalesOrderIdwithPlaced, setSalesorderIdwithPlaced] = useState("");
  const [InstructionsDialog, setInstructionsDialog] = useState("");
  const [TapPage, setTapPage] = useState(0);
  const [pageInfo, setPageInfo] = useState(false);
  const [OrganizationDetails, setOrganizationDetails] = useState("Loading");
  const [callDownloadPDF, setCallDownloadPDF] = useState({
    isDataLoaded: false,
    executeDownloadPDFFunction: false
  });
  const [FetchLimit, setFetchLimit] = useState({ order: 125, delivery: 125, invoice: 125, crditNote: 125 });
  const [pageLoading, setPageLoading] = useState(false);
  const [EditImageData, setEditImageData] = useState('');
  const [visible, setVisible] = useState(true);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  // getting checkbox invoices from grid
  const [invoicesToPay, setInvoicesToPay] = useState([]);
  const [scrollPosition, setScrollPosition] = useState(0);
  const isMobile = useMediaQuery("(max-width:500px)");

  const [showView, setShowView] = useState({
    showOrderDetails: false,
    showDeliveryDetails: false,
    showPaymentHistoryDetails: false,
    showCreditNoteDetails: false,
    showInvoiceDetails: false,
    showInvoicPayment: false
  });

  // getting checkbox invoices from card
  const [selectedInvoices, setSelectedInvoices] = useState(new Set());

  const [rtl, setRtl] = useState(false);
  const [notificationData, setNotificationData] = useState('');
  const [additionalPricingOptions, setAdditionalPricingOptions] = useState('');
  const [loadingPriceList, setLoadingPriceList] = useState(false);
  const [isSessionExpired, setIsSessionExpired] = useState(false);
  const [SalesBlockList, setSalesBlockList] = useState(false);
  const [OpenSearchInputText, setOpenSearchInputText] = useState("");

  useEffect(() => {
    const handleOnlineStatus = () => {
      setIsOnline(navigator.onLine);
    };

    window.addEventListener('online', handleOnlineStatus);
    window.addEventListener('offline', handleOnlineStatus);

    return () => {
      window.removeEventListener('online', handleOnlineStatus);
      window.removeEventListener('offline', handleOnlineStatus);
    };
  }, []);


  //getting Login User Data
  async function fetchUserAttributes() {
    try {
      const user = await Auth.currentAuthenticatedUser();
      // console.log("user 1",user)
      setUsername(user.signInUserSession.idToken.payload.name);
      setUserDetails(user.signInUserSession.idToken.payload);
    } catch (error) {
      console.error("Error fetching user attributes:", error);
    }
  }

  //Fetching ProductDetails for show in catalog page using use context
  const fetchProductDetails = async () => {

    setProductListDetails(1)
    let nextToken = null;
    let productList = [];

    try {

      do {
        const result = await API.graphql({
          query: AdminlistProductsLists,
          variables: {
            limit: 3000,
            nextToken: nextToken,
          },
        });

        if (result.data.listProductsLists.items.length === 0 && productList.length === 0 && result.data.listProductsLists.nextToken === null) {
          nextToken = null;
          setProductListDetails(0)
        }
        else {
          nextToken = result.data.listProductsLists.nextToken;
          const productItems = result.data.listProductsLists.items.map((p) => {
            const newProduct = { ...p };
            if (p.ProductsPrices && p.ProductsPrices.items && p.ProductsPrices.items.length > 0) {
              newProduct.ProductPrice = p.ProductsPrices.items[0].ProductPrice;
              newProduct.ProductPriceCSV = p.ProductsPrices.items[0].ProductPrice;
              newProduct.ProductIdCSV = p.ProductsPrices.items[0].ProductId;
              newProduct.ProductPriceCurrencyCode = p.ProductsPrices.items[0].ProductPriceCurrencyCode === null ? "" : p.ProductsPrices.items[0].ProductPriceCurrencyCode;
              newProduct.ProductPriceCurrencyCodeText = p.ProductsPrices.items[0].ProductPricecurrencyCodeText;
              newProduct.ProductPriceQuantity = p.ProductsPrices.items[0].ProductPriceQuantity === null ? null : parseFloat(p.ProductsPrices.items[0].ProductPriceQuantity);
              newProduct.ProductPriceUOM = p.ProductsPrices.items[0].ProductPriceQuantityCode === null ? "" : p.ProductsPrices.items[0].ProductPriceQuantityCode;
            }
            else {
              newProduct.ProductPrice = null;
              newProduct.ProductPriceCurrencyCode = "";
              newProduct.ProductPriceQuantity = null;
              newProduct.ProductPriceUOM = ""
            }
            // if (p.ProductsPrices.items[0].ProductPriceQuantity === null) {

            //   console.log("newProduct", newProduct);
            // }
            return newProduct;

          });

          productList = productList.concat(productItems);
          // console.log("productList", productList)
          // if (productList.concat(productItems).length >= 10 || productList.concat(productItems).length <= 0) {
          //   nextToken = null;
          // }

        }

      } while (nextToken);
      if (productList.length === 0) {
        setProductListDetails(0)
      } else {
        setProductListDetails(productList);
      }

    }
    catch (error) {
      setProductListDetails(0)
      // showToast("Oops! Something went wrong while fetching products. ", "error")
      console.error("Fetching error in Admin Products", error)
    }

  };


  useEffect(() => {
    if (props.role) {
      setIsLoggedIn(true);
    }
    else {
      setIsLoggedIn(false);
      setIsSessionExpired(true);
    }
    // eslint-disable-next-line 
  }, [])

  const FetchNotificationFn = async () => {
    const notificationDeatils = await fetchNotificationDetails({ role: props.role, t });
    setIsSessionExpired(notificationDeatils.sessionExpired);
    setNotificationMsg(notificationDeatils.apiResponse);
  }

  const FetchingCustomerAPIs = async () => {
    // getting org Details 
    const orgDetails = await OraganizationLists({ t });
    setTaxDetails(orgDetails.apiResponse);
    setShow(orgDetails.orgDetailsshow);


    if (!Mobile) {
      await FetchRestrictCustomerSpecificProductsByCustomerUUID({ ProductRelatedDispatch, Actions });
      FetchCartDetailsFn({ CartRelatedDispatch, Actions }).then(() => {
        OpenSearchProductsDetails({
          SearchText: "ListByProduct", StartFrom: 0, ProductRelatedDispatch,
          Actions, ProductCountSize: ProductRelatedStates.ProductCountSize
        });
        FetchFavProductsDetails({ ProductRelatedDispatch, Actions });
        FetchUOMDetails({ ProductRelatedDispatch, Actions })
      })
    }
    // getting customer addressdetails 
    setaccountDetails(await fetchCustomerAddress({ t }));
    //getting user details 
    fetchUserAttributes();

    //getting customer black list API
    setSalesBlockList(await FetchCustomerBlockDetails({ t, taxDetails: orgDetails.apiResponse }))

    // getting Notification details 
    FetchNotificationFn();


  }

  useEffect(() => {
    if (Object.keys(taxDetails).length > 0) {
      props.getOrganizationDetails(taxDetails);
    }
    // eslint-disable-next-line 
  }, [taxDetails]);



  useEffect(() => {
    const rootElement = document.getElementById("root");
    if (rootElement) {
      let direction = rtl ? "rtl" : "ltr";
      rootElement.setAttribute("dir", direction);
    }
  }, [rtl])

  useEffect(() => {
    // user based function called 
    if (props.role === 'Customers') {
      FetchingCustomerAPIs();
    }

    // Admin based panel setup 
    if (props.role === 'Admin') {
      fetchProductDetails();
      fetchUserAttributes();
      FetchNotificationFn();
      // fetchNotificationDetails({ role: props.role, t })
      OraganizationList(setOrganizationDetails, setShow);
    }
    // eslint-disable-next-line 
  }, [rtl, Mobile]);

  useEffect(() => {
    if (parseInt(sessionStorage.getItem("TapPagNumber")) > 0) {
      setTapPage(parseInt(sessionStorage.getItem("TapPagNumber")));
    }
    else {
      setTapPage(0);
    }
  }, [TapPage])



  //Customer context variables
  const AppContextValue = {
    isMobile,
    show,
    setShow,
    rtl,
    setRtl,
    isSidebarOpen,
    setIsSidebarOpen,
    username,
    setUsername,
    userDetails,
    setUserDetails,
    Actions,
    ProductRelatedStates, ProductRelatedDispatch,
    CartProductRelatedStates, CartRelatedDispatch,
    ProductListDetails,
    setProductListDetails,
    favouritesTab,
    setFavouritesTab,
    date,
    setDate,
    rootObject,
    setRootObject,
    DialogBox,
    setDialogBox,
    globalSearch,
    setGlobalSearch,
    globalData,
    setGlobalData,
    accountDetails,
    isFiltered,
    setIsFiltered,
    filteredData,
    setFilteredData,
    taxDetails,
    setTaxDetails,
    isCollapsed, setIsCollapsed,
    showProductDetails, setShowProductDetails,
    isLoggedIn, setIsLoggedIn,
    NotificationMsg, setNotificationMsg,
    SalesOrderIdwithPlaced, setSalesorderIdwithPlaced,
    callDownloadPDF, setCallDownloadPDF,
    FetchLimit, setFetchLimit,
    pageInfo, setPageInfo,
    TapPage, setTapPage,
    pageLoading, setPageLoading,
    OpenSearchInputText, setOpenSearchInputText,
    OpenSearchProductsDetails,
    showView, setShowView,
    selectedInvoices, setSelectedInvoices,
    invoicesToPay, setInvoicesToPay,
    scrollPosition, setScrollPosition,
    SalesBlockList,
    isSessionExpired, setIsSessionExpired,
    MobileBackComp, setMobileBackComp
  };



  const currentpath = useLocation();
  //***********Thiyagu changes************/
  useEffect(() => {
    if (taxDetails.SAPFiscalYearVariant === "13" ||
      taxDetails.SAPFiscalYearVariant === "32") {

      if (currentpath.pathname === "/order" || currentpath.pathname === "/delivery") {
        setDate((new Date().getFullYear()))
      } else {
        setDate((new Date().getFullYear()) - 1)
      }

    }
    else if (taxDetails.SAPFiscalYearVariant === "10") {
      setDate((new Date().getFullYear()))
    }
    // eslint-disable-next-line
  }, [taxDetails.SAPFiscalYearVariant])



  //Admin context variables
  const adminContextValue = {
    isSessionExpired, setIsSessionExpired,
    loadingPriceList, setLoadingPriceList,
    additionalPricingOptions, setAdditionalPricingOptions,
    isMobile,
    show,
    setShow,
    rtl,
    setRtl,
    isSidebarOpen,
    setIsSidebarOpen,
    ProductListDetails,
    setProductListDetails,
    username,
    setUsername,
    userDetails,
    setUserDetails,
    date,
    setDate,
    rootObject,
    setRootObject,
    taxDetails,
    setTaxDetails,
    isCollapsed, setIsCollapsed,
    isLoggedIn, setIsLoggedIn,
    NotificationMsg, setNotificationMsg,
    TapPage, setTapPage,
    InstructionsDialog, setInstructionsDialog,
    OrganizationDetails, setOrganizationDetails,
    pageInfo, setPageInfo,
    EditImageData, setEditImageData,
    fetchProductDetails,
    notificationData, setNotificationData
  };

  const handleRefresh = () => {
    window.location.reload();
    setVisible(false);
  }

  const footerContent = (
    <div>
      <Button label="Refresh" icon="pi pi-refresh" onClick={handleRefresh} autoFocus />
    </div>
  );


  //  UseEffect for REmoved Product in the open search API call filling the gap for that 
  useEffect(() => {
    if (ProductRelatedStates.GapFillingCount > 0 && ProductRelatedStates.CatalogProductList.NextToken) {
      ProductRelatedDispatch({ type: Actions.NextTokenRestart })
      OpenSearchProductsDetails({
        SearchText: OpenSearchInputText === "" ? "ListByProduct" : OpenSearchInputText,
        StartFrom: ProductRelatedStates.CatalogProductList.TotalProductCount,
        ProductRelatedDispatch, Actions,
        ProductCountSize: ProductRelatedStates.GapFillingCount
      });
    }

  }, [ProductRelatedStates.GapFillingCount, ProductRelatedStates.CatalogProductList.NextToken])




  return (
    <>

      {/* Checks the session */}
      {
        isSessionExpired &&
        <SessionExpired />
      }
      {/* Checks internet connection */}
      {
        !isOnline && (

          <div className="card flex justify-content-center">
            <Dialog className="text-base md:text-lg" header="You're offline" visible={visible} onHide={() => setVisible(false)} footer={footerContent}
              style={{ width: '50vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }}>
              <div className="network-error fadein animation-duration-1000 animation-iteration-infinite">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                  strokeLinecap="round" strokeLinejoin="round" className="feather feather-wifi-off">
                  <line x1="1" y1="1" x2="23" y2="23" />
                  <path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55M5 12.55a10.94 10.94 0 0 1 5.17-2.39M10.71 5.05A16 16 0 0 1 22.58 9M1.42 9a15.91 15.91 0 0 1 4.7-2.88M8.53 16.11a6 6 0 0 1 6.95 0M12 20h0" />
                  <circle cx="12" cy="12" r="1" />
                </svg>
              </div>
              <p className="mt-3 font-semibold text-sm md:text-base flex justify-content-center align-items-center">
                Please check your network connection and try refreshing the page.
              </p>
            </Dialog>
          </div>
        )
      }
      {/* Admin Logout */}
      {
        (props.role === 'Admin' && isLoggedIn) &&
        <AppContext.Provider value={adminContextValue}>

          {/* {!rtl && <AdminSidebar />} */}
          <AdminSidebar />

          <main className="content">
            <AdminTopbar />
            {show === "Logout" && (
              <AdminDialogComponent
                header={t(`Logout`)}
                title={t(`Are you sure you want to logout?`)}
                signout={props.SīgnOut}
              />
            )}
            {show === "ContactSyncFinish" && (
              <AdminDialogComponent
                header={t(`Info`)}
                title={t(`The contact details have been synchronized successfully. Please refresh the table.`)}
              // signout={props.SīgnOut}
              />
            )}
            {show === "ProductSyncFinish" && (
              <AdminDialogComponent
                header={t(`Info`)}
                title={t(`The product details have been synchronized successfully. Please refresh the table.`)}
              // signout={props.SīgnOut}
              />
            )}
            {show === "PriceSyncFinish" && (
              <AdminDialogComponent
                header={t(`Info`)}
                title={t(`The product price details have been synchronized successfully. Please refresh the table.`)}
              // signout={props.SīgnOut}
              />
            )}
            <Outlet />
          </main>

          {/* {rtl && <AdminSidebar />} */}

        </AppContext.Provider>
      }

      {/* User outlet */}
      {
        (props.role === 'Customers' && isLoggedIn) &&
        <AppContext.Provider value={AppContextValue}>
          <FadeProvider>

            {(!Mobile) && <Sidebar />}
            {(Mobile && !MobileBackComp) && <Footer />}

            <main className="content">
              {!Mobile && <Topbar />}

              {show === "PaymentSuccess" && (
                <DialogComponent header={t(`Payment Success`)} title={t(`Your Payment recieved successfully 👍`)} />
              )}

              {show === "PaymentAdvice Updated" && (
                <DialogComponent header={t(`Payment Advice Updated`)} title={t(`Your recent Bank Payment advice cleared successfully 👍`)}
                />
              )}
              {show === "PaymentAdviceCreationError" && (
                <DialogComponent header={t(`Payment Advice Creation Error`)}
                  title={t(`Your payment is confirmed. However we are unable to clear invoices in the SAP system as of now. Please reach out to your point of contact.`)}
                />
              )}
              <Outlet />
            </main>

            {/* {(!isMobile && rtl) && <Sidebar />} */}



          </FadeProvider>
        </AppContext.Provider>
      }

    </>
  )
};

export default Layout;
